const INIT = { requests: {} };

export default function loadingReducer(state = INIT, action) {
  const match = /(.*)_(REQUEST|SUCCESS|ERROR)/.exec(action.type);
  if (!match) return state;
  const [, requestName, status] = match;
  return {
    ...state,
    requests: {
      ...state.requests,
      [requestName]: status === 'REQUEST',
    },
  };
}

export const createLoadingSelector = (actions) => (state) =>
  actions.some((a) => state.api.loading.requests[a.ACTION]);
